import * as types from './mutation-types';

export default {
  [types.SET_NATUREZA_COLLECTION](state, payload) {
    state.naturezaCollection = payload;
  },
};
